import * as ActionTypes from '../constants/ActionTypes';
import Network from '../utils/network';
import { server } from '../constants/SiteVariables';
import request from '../utils/request';

export const sendContact = (email, message, name) => {
  return (dispatch, getState) => {
    return request(server(true) + '/index.php?id=contact', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        async: true,
        name: name,
        email: email,
        message: message
      })
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/contact.js